(function() {
    "use strict";
  
    angular
  
      .module("modules.authServices", []);
  })();